import React from 'react';

import { Box } from '@material-ui/core';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

import useStyles from './styls';

interface RolesViewSwitcherProps {
  leftBtnLink?: string;
  rightBtnLink?: string;
  wrapperClass?: string;
}

const RolesViewSwitcher: React.FC<RolesViewSwitcherProps> = ({
  leftBtnLink,
  rightBtnLink,
  wrapperClass = '',
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const history = useHistory();
  const currentPath = history?.location?.pathname;

  return (
    <Box className={cx(classes.wrapper, wrapperClass)}>
      <Link
        className={cx(classes.roleBtn, currentPath === leftBtnLink && 'active')}
        to={leftBtnLink}
      >
        {t('button.managerView')}
      </Link>
      <Link
        className={cx(classes.roleBtn, currentPath === rightBtnLink && 'active')}
        to={rightBtnLink}
      >
        {t('button.userView')}
      </Link>
    </Box>
  );
};

export default RolesViewSwitcher;
